export const START_STEP = "test-id-review-form-start-step";
export const START_STEP_NEXT_BUTTON = "test-id-review-form-start-step-next-button";
export const FORM_STEP = "test-id-review-form-form-step";
export const FINISH_STEP = "test-id-review-form-finish-step";
export const ERROR_MESSAGE = "test-id-review-form-error-message";
